import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

import { LINKS } from "../../constants";

export const VerifiedRoute = ({ isAbleForGuests = false, children }) => {
  const location = useLocation();
  const path = location.pathname;
  const { isAuthenticated, verified, demoWizard } = useSelector(
    (state) => state.auth
  );

  if (!isAbleForGuests && !isAuthenticated) {
    return <Navigate to={LINKS.login} replace />;
  }
  if (isAuthenticated && !verified) {
    return <Navigate to={LINKS.unverified} replace />;
  }
  if (
    isAuthenticated &&
    !demoWizard?.ignoreWizard &&
    path !== LINKS.welcomeWizard
  ) {
    // return <Navigate to={LINKS.welcomeWizard} replace />;
    return <Navigate to={LINKS.welcomeWizard} />;
  }
  return children;
};

VerifiedRoute.propTypes = {
  isAbleForGuests: PropTypes.bool,
  children: PropTypes.object.isRequired,
};
